import React from "react";
import PropTypes from "prop-types";
import Product from "./Product";
import H from "../../../common/Typography/H";

import styles from "./category.module.scss";

function Category({title, items}) {
  return (
    <div className={styles.root}>
      <H level={2} className={styles.title}>
        {title}
      </H>
      <div className={styles.content}>
        {items.map(
          ({
            singular,
            title: itemTitle,
            preview,
            minPrice,
            editorPath,
            options
          }) => (
            <Product
              key={singular}
              productName={singular}
              title={itemTitle}
              preview={preview}
              minPrice={minPrice}
              editorPath={editorPath}
              options={options}
            />
          )
        )}
      </div>
    </div>
  );
}

Category.propTypes = {
  title: PropTypes.string,
  path: PropTypes.string,
  items: PropTypes.array
};

export default Category;
